module.exports = __webpack_public_path__ + "media/hallBgm.395ba08d.mp3";